module.exports = __webpack_public_path__ + "img/vue1-toebox_blanc.cb680e95.png";